import { Theme, alpha } from "@mui/material";

// Soft, warm shadows. Visible enough to "lift" surfaces, never dramatic.
// In dark mode shadows need higher opacity to read against dark backgrounds.
export const shadows = (theme: Theme): any => {
  const { mode } = theme.palette;
  const isLight = mode === "light";
  const baseColor = isLight ? "#0C0A09" : "#000000";
  const a = (op: number) => alpha(baseColor, isLight ? op : Math.min(op * 4, 0.7));

  const e0 = "none";
  const e1 = `0 1px 2px ${a(0.05)}`;
  const e2 = `0 1px 3px ${a(0.06)}, 0 1px 2px ${a(0.04)}`;
  const e3 = `0 4px 10px -2px ${a(0.06)}, 0 2px 4px -2px ${a(0.04)}`;
  const e4 = `0 8px 16px -4px ${a(0.07)}, 0 4px 8px -4px ${a(0.05)}`;
  const e6 = `0 14px 24px -8px ${a(0.09)}, 0 6px 12px -6px ${a(0.06)}`;
  const e8 = `0 20px 32px -12px ${a(0.12)}, 0 10px 16px -10px ${a(0.07)}`;
  const e12 = `0 28px 44px -18px ${a(0.14)}, 0 14px 22px -14px ${a(0.08)}`;
  const e16 = `0 36px 56px -22px ${a(0.16)}`;
  const e24 = `0 48px 72px -26px ${a(0.2)}`;

  return [
    e0,
    e1,
    e2,
    e3,
    e4,
    e4,
    e6,
    e6,
    e8,
    e8,
    e8,
    e12,
    e12,
    e12,
    e12,
    e16,
    e16,
    e16,
    e16,
    e24,
    e24,
    e24,
    e24,
    e24,
    e24,
  ];
};
